import {
    apiRequest,
    employeeStatusCreate,
} from "../../../../../services/adapters/master/employeeStatusService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", employeeStatusCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository